import { render, staticRenderFns } from "./CongratulationsSection.vue?vue&type=template&id=19925552&scoped=true"
import script from "./CongratulationsSection.vue?vue&type=script&lang=js"
export * from "./CongratulationsSection.vue?vue&type=script&lang=js"
import style0 from "./CongratulationsSection.vue?vue&type=style&index=0&id=19925552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19925552",
  null
  
)

export default component.exports